import React, { useState, useEffect, useContext } from 'react';

import { useSDK } from "../../scandit/sdk";
import ScannerComponent from "../../scandit/ScannerComponent";

// import * as SDCCore from "scandit-web-datacapture-core";
// import * as SDCBarcode from "scandit-web-datacapture-barcode";
// import { DataCaptureContext,FrameSourceState, Camera } from "scandit-web-datacapture-core";
// import { barcodeCaptureLoader } from "scandit-web-datacapture-barcode";


import styles from '../../styles/BarcodeScanner.module.scss';
import {AnimatePresence, motion} from 'framer-motion';
import { useUserAPI } from '../../components/useUserAPI';
import { ShoppingStart } from '../../components/ShoppingStart';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';

// import useSound from 'use-sound';
// import se_07_scan from '../../sound/s07_scan.mp3';
// import se_08 from '../../sound/s08_se_delay0.mp3';

//スキャンを止めたまま読み取り値が来ない場合に、再開するまでの待ち時間
const SCAN_STALL_TIMEOUT = 5000;

function BarcodeScanner(props) {

//----------------------------------------
// scandit
//----------------------------------------

const { loaded, sdk, error } = useSDK();

// const [se07_scan] = useSound(se_07_scan);
// const [se08_se] = useSound(se_08);

// const { onScan, setPage, trueBarcode, setTrueBarcode } = props;

const ShoppingStartContext = useContext(ShoppingStart);
const [firstScan, setFirstScan] = useState(true);
//取得バーコード検証用
const [barcode, setBarcode] = useState();
// const scanFlgRef = useRef(props.scanFlg);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);

//スキャン有効化
useEffect(() => {
	if(firstScan === true){
		setFirstScan(false);
	}else{
		console.log("props.scanFlg: " + props.scanFlg);
		// props.scanFlg true: スキャン不可 false:スキャン可
		if(props.scanFlg === false && firstScan === false){
			(async () => {
				setBarcode();
				if (loaded) {
					// await sdk.enableScanning(true);
					// await sdk.enableCamera(false);
					try {
						await sdk.enableScanning(true);
					} catch (e) {
						console.error("enableScanning failed:", e);

						// ユーザー向け表示
						props.setErrFlg(true);
						let err_msg = ";;"+e+";;;";
						props.setErr([true,``, err_msg]);

						// 再トライ暴発を避けたい場合はスキャン不可に戻す（任意）
						// props.setScanFlg(true);

						//ログアップロードAPI
						loguploadAPI(sharedInfo.transactionno, `scandit:enableScanning error, ${e}`);
					}
				}
			})();
		}
	}
}, [props.scanFlg]);


//----------------------------------------
//scanditエラー表示
//----------------------------------------

const sharedInfo = useContext(SharedInfoContext);

useEffect(() => {
	if(String(error).indexOf("NotAllowedError: Permission denied") !== -1){
		console.log("error: " + error);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_SCANDIT_NOTALLOW]);
		// props.setErr([true,``,`;;カメラの利用が許可されていません;;;`]);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"scandit:error, " + error);

	}else if(String(error) !== "undefined" && String(error) !== undefined && String(error) !== ""){
		console.log("error: " + error);
		props.setErrFlg(true);
		let err_msg = ";;"+error+";;;";
		props.setErr([true,``, err_msg]);
		// props.setErr([true,``,`;;カメラの利用が許可されていません;;;`]);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"scandit:error, " + error);
	}
}, [error]);


//----------------------------------------
//ログアップロードAPI
//----------------------------------------

const { loguploadAPI, data: loguploadData, loading: loguploadLoading, error: loguploadError } = useUserAPI();

//ログアップロードAPI：レスポンス
useEffect(() => {
	if(loguploadData){
		console.log(loguploadData);
		if (loguploadData.isSuccess == true) { //SUCCESS
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
		}else{ //ERROR
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
			console.log(`【loguploadAPI】 errorCode: ${loguploadData.errorCode}`);
			console.log(`【loguploadAPI】 errorMessage: ${loguploadData.errorMessage}`);
		}
	}
}, [loguploadData]);


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	setTimeout(function(){
		document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	}, 100);

	// iOS16の場合に特定の処理を行う
	// if (isiOSVersion16()) { //iOS16：スキャンエリア設定
	// 	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
	// 		setTimeout(function(){
	// 			(async () => {
	// 				const scannerArea = document.getElementById("barcode-scanner-area");
	// 				if (scannerArea) {
	// 					document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	// 					const rect = scannerArea.getBoundingClientRect();
	// 					const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
	// 					await sdk.setScanArea(rect,viewRect);
	// 				}
	// 			})();
	// 		}, 600);
	// 	}else { //iAEON無効
	// 		setTimeout(function(){
	// 			document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	// 		}, 300);
	// 	}
	// } else { //スキャンエリア設定
	// 	setTimeout(function(){
	// 		(async () => {
	// 			const scannerArea = document.getElementById("barcode-scanner-area");
	// 			if (scannerArea) {
	// 				document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	// 				const rect = scannerArea.getBoundingClientRect();
	// 				const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
	// 				await sdk.setScanArea(rect,viewRect);
	// 			}
	// 		})();
	// 	}, 600);
	// }

	//arrows We 対応
	// document.documentElement.style.zoom = window.innerWidth / 390;
	// var zratio = window.innerWidth / 390;
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('scan');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}

}, []);


//----------------------------------------
//商品登録API
//----------------------------------------

const { shoppingPurchaseAPI, data: shoppingPurchaseData, loading: shoppingPurchaseLoading, error: shoppingPurchaseError, scnflg: shoppingPurchaseScanFlg } = useUserAPI();
//API を呼び出せる状態かを管理するフラグ：初期値は true で、API を呼び出すたびに false に設定し、タイマーで 1 秒後に true に戻す
const [isApiCallAllowed, setIsApiCallAllowed] = useState(true);

//商品登録API：呼び出し制限
useEffect(() => {
	console.log("barcode: " + barcode);
	console.log("isApiCallAllowed: " + isApiCallAllowed);
    if (barcode && isApiCallAllowed && !shoppingPurchaseLoading) {
        console.log("【商品登録API call】---------------------------");
        shoppingPurchaseAPI(barcode, ShoppingStartContext.data.token);
        console.log("【/商品登録API call】---------------------------");

        // API呼び出し制御をfalseにし、1秒後にtrueに戻す
        //※このタイマーをクリーンアップで解除してはいけない。
        //　このeffectは barcode が変わるたびに再実行され、その直前に前回のクリーンアップが走る。
        //　API呼び出しから1秒以内に barcode が変化するとタイマーが解除され、
        //　isApiCallAllowed が false のまま戻らなくなり、以降ずっとAPIを呼べなくなる
        setIsApiCallAllowed(false);
        setTimeout(() => {
            setIsApiCallAllowed(true);
        }, 1000);
    }else {
        //どの条件でAPIを呼ばなかったのかを出す。
        //※読み取り値がまだ無いだけの状態（画面を開いた直後や、検知値をクリアした直後）でも
        //　ここを通る。以前は一律で「再呼び出し制限中」と出していたため、
        //　制限で止まっているように見えて紛らわしかった
        if (!barcode) {
        	console.log("【商品登録API】読み取り値なし（待機中）");
        } else if (shoppingPurchaseLoading) {
        	console.log("【商品登録API】通信中のため見送り");
        } else {
        	console.log("【商品登録API call】再呼び出し制限中");
        }

        //APIを呼ばずに抜けた場合はレスポンスもエラーモーダルも発生しないため、
        //検知時に止めたスキャンを戻す契機が無く画面が固まる。
        //スキャン状態を戻して読み直せるようにする（通信中はレスポンス側で戻すので触らない
        if (barcode && !shoppingPurchaseLoading) {
            setBarcode();
            props.setScanFlg(false);
        }
	}
}, [barcode]);


//----------------------------------------
//スキャン停止からの復帰（保険
//----------------------------------------
// 検知時は「スキャンを止める → 読み取り値をstateへ渡す」の順で処理している。
// scandit は停止処理が非同期（enableScanning(false) → enableCamera(false)）のため、
// 低スペック端末でここが失敗・遅延すると、値がstateへ渡らないまま終わることがある。
// その場合 scanFlg が true のまま戻す契機が無く、以降スキャンできなくなる。
// 「スキャンを止めているのに読み取り値が無い」状態が続いたら再開させる。
//
// ※ここでの clearTimeout は正しい。条件が変わったら判定をやり直したいため。
// 　上のAPI呼び出し制限のタイマーとは意図が逆なので混同しないこと

useEffect(() => {
	//スキャン可・エラーモーダル表示中・読み取り値ありは対象外
	if (props.scanFlg !== true) return;
	if (props.errFlg === true) return;
	if (barcode) return;

	const timer = setTimeout(() => {
		console.log("【scan】スキャンを止めたまま読み取り値が来ないため再開する");
		props.setScanFlg(false);
	}, SCAN_STALL_TIMEOUT);

	return () => clearTimeout(timer);
}, [props.scanFlg, props.errFlg, barcode]);

// useEffect(() => {
// 	if(barcode){
// 		console.log("【商品登録API call】---------------------------");
// 		shoppingPurchaseAPI(barcode,ShoppingStartContext.data.token);
// 		console.log("【/商品登録API call】---------------------------");
// 	}
// }, [barcode]);

//商品登録API：レスポンス
useEffect(() => {
	// console.log("useEffect purchaseData");
	if(shoppingPurchaseData){
		// console.log("ああああ");
		if (shoppingPurchaseData.data) { //SUCCESS
			// console.log("いいいい");
			// if(barcodeCapture){
			// 	barcodeCapture.removeListener(listener);
			// 	barcodeCapture.setEnabled(false);
			// }
			// se07_scan();
			props.setSoundState("se07_scan");

			console.log(`【shoppingPurchaseAPI】 receiptKanji: ${shoppingPurchaseData.data.receiptKanji}`);
			console.log(`【shoppingPurchaseAPI】 sellPrice: ${shoppingPurchaseData.data.sellPrice}`);
			console.log(`【shoppingPurchaseAPI】 discountSellPrice: ${shoppingPurchaseData.data.discountSellPrice}`);

			props.setShoppingData(shoppingPurchaseData);
			setScanItem(true);
			setTimeout(function(){
				// setTrueBarcode("");
				setScanItem(false);
				// props.setScanFlg(false);
				(async () => {
					if (loaded) {
						// await sdk.enableScanning(true);
						await sdk.enableCamera(false);
					}
				})();
				document.getElementById('scanBox').classList.remove(`${styles.is_show}`);
				props.setPage("shopping");
			}, 2500);
		}else{ //ERROR
			// console.log("うううう");
			console.log(`【shoppingPurchaseAPI】 errorCode: ${shoppingPurchaseData.errorCode}`);
			console.log(`【shoppingPurchaseAPI】 errorMessage: ${shoppingPurchaseData.errorMessage}`);
			console.log(`【shoppingPurchaseAPI】 isSuccess: ${shoppingPurchaseData.isSuccess}`);

			// se07_scan();
			props.setSoundState("se07_scan");
			// (async () => {
			// 	await sdk.enableScanning(false);
			// 	// await sdk.enableCamera(false);
			// })();

			if(shoppingPurchaseData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${shoppingPurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${shoppingPurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(shoppingPurchaseData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${shoppingPurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${shoppingPurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				// props.setErrNum(`${shoppingPurchaseData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${shoppingPurchaseData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${shoppingPurchaseData.errorCode}`,`${shoppingPurchaseData.errorMessage}`]);

				// console.log("barcodeCapture");
				// console.log(barcodeCapture);
				// setTimeout(function(){
					// if(barcodeCapture){
					// 	// barcodeCapture.addListener(listener);
					// 	barcodeCapture.setEnabled(true);
					// }
					// console.log("【scandit】restart");
					// initScann();
					// props.setScanFlg(false);
				// }, 2200);
			}
		}
	}
	if(shoppingPurchaseError){
		console.log("shoppingPurchaseError");
		console.log(shoppingPurchaseError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(shoppingPurchaseLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
	// if(shoppingPurchaseScanFlg === true){
	// 	props.setScanFlg(false);
	// }
}, [shoppingPurchaseData,shoppingPurchaseLoading,shoppingPurchaseError,shoppingPurchaseScanFlg]);


//----------------------------------------
//スキャン閉じる（買物一覧画面へ
//----------------------------------------

const onScanClose = async () => {
	(async () => {
		if (loaded) {
			await sdk.enableScanning(false);
			await sdk.enableCamera(false);
		}
	})();
	document.getElementById('scanBox').classList.remove(`${styles.is_show}`);

	// setScanItem(false);
	props.setPage("shopping");
	// se08_se();
	props.setSoundState("se08_se");
}

const [scanItem, setScanItem] = useState(false)

const motionConfig = {
	initial: {
		y: -20,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 20,
		opacity: 0,
	},
};


return (
<div id="scan" className="container l_contents">

<header id="header02" className={`l_header02 ${bandColor}`}>
	<button href="" className="header02_backBtn" onClick={onScanClose}>
		<img src="/images/icn_back01_white.svg" alt="" width="24" height="24"/>
	</button>
	<p className="header02_tit">スキャン中</p>
</header>

<div className={styles.msgBox}>
	<p className={styles.msgBox_txt}>商品のバーコードを<br/>枠内に入れてください</p>
</div>

<div id="scanBox" className={styles.scanBox}>
	<div id="barcode-scanner-area" className={styles.scanArea}></div>
	<div className={styles.scanBoxBlack}></div>
	<div className={styles.scanCover}></div>
	<div id="barcode-scanner" className={`${styles.scanImg} ${styles.scanImg02}`}></div>
	<ScannerComponent setBarcode={setBarcode} setScanFlg={props.setScanFlg}/>
</div>

<AnimatePresence>
	{scanItem && (
		// {setScanItem ? ( // showModalがtrueだったらModal表示
		// if(shoppingPurchaseData){ // showModalがtrueだったらModal表示
		<motion.div id="addItem" className={styles.addItem}
		initial={'initial'}
		animate={'animate'}
		exit={'hidden'}
		variants={motionConfig}
		transition={{duration: 0.4, ease: 'easeOut'}}
		>
				<div className={styles.addItem_head}>
					<p className={styles.addItem_head_txt}>
						<span className={styles.addItem_head_check}>
							<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
						</span>
						商品を追加しました
					</p>
				</div>
				<div className={styles.addItem_box}>
					<div className={styles.addItem_in}>
						<div className={styles.addItem_img}>
							{/* <img src="/images/img_item02.png" alt="" width="40" height="40"/> */}
							<img src={shoppingPurchaseData.data.itemUrl ? shoppingPurchaseData.data.itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
							{/* <img src={shoppingPurchaseData.data.itemUrl} alt="" width="40" height="40"/> */}
						</div>
						<p className={styles.addItem_name}>{shoppingPurchaseData.data.receiptKanji}</p>
						{/* <p className={styles.addItem_name}>トップバリュ 糖質をおさえたブランデニッシュ 2個入</p> */}
						<div className={styles.addItem_priceBox}>
							<p className={styles.addItem_price}>
								<span className={`${styles.addItem_price_default} ${shoppingPurchaseData.data.discountSellPrice ? styles.cancel : ''}`}><small>¥</small>
								{
									(() => {
										return (
											(shoppingPurchaseData.data.sellPrice).toLocaleString('ja-JP')
										)
										// if (shoppingPurchaseData.data.discountSellPrice != null) {
										// 	return shoppingPurchaseData.data.discountSellPrice;
										// } else {
										// 	return shoppingPurchaseData.data.sellPrice;
										// }
									})()
								}
								</span>

								{/* <span className="addItem_price_default cancel"><small>¥</small>198</span> */}
							</p>
						</div>
					</div>
					{
						(() => {
							if (shoppingPurchaseData.data.discountType === 1) {
								return(
									<div className={styles.addItem_discount}>
										<p className={styles.addItem_discount_txt}>レジにて<strong>{(shoppingPurchaseData.shoppingPurchaseData.data.discountAmount).toLocaleString('ja-JP')}</strong>円引き</p>
										<p className={styles.addItem_discount_price}><small>¥</small>{(shoppingPurchaseData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}else if (shoppingPurchaseData.data.discountType === 2) {
								return(
									<div className={styles.addItem_discount}>
										<p className={styles.addItem_discount_txt}>レジにて<strong>{shoppingPurchaseData.data.discountAmount}</strong>%OFF</p>
										<p className={styles.addItem_discount_price}><small>¥</small>{(shoppingPurchaseData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}else if (shoppingPurchaseData.data.discountType === 3) {
								return(
									<div className={styles.addItem_discount}>
										<p className={styles.addItem_discount_txt}>レジにて</p>
										<p className={styles.addItem_discount_price}><small>¥</small>{(shoppingPurchaseData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}
						})()
					}
					{/* <div className="addItem_discount">
						<p className="addItem_discount_txt">レジにて<strong>30</strong>%OFF</p>
						<p className="addItem_discount_price"><small>¥</small>138</p>
					</div> */}

				</div>
		</motion.div>
		// }
	)}
</AnimatePresence>
</div>
		// </>
)
}

export default BarcodeScanner
